import classNames from "classnames";
import { isPlainObject, noop } from "lodash";
import React, { MouseEvent, ReactNode } from "react";

import "./ACSegmented.less";

type ItemTypeObject = { label: ReactNode; value: string };
type ItemType = ItemTypeObject | string;

type Props = React.HTMLAttributes<HTMLDivElement> & {
  items: ItemType[];
  onChange: (value: string) => void;
  value: string;
  disabled?: boolean;
};

export default function ACSegmented({
  items,
  onChange,
  value,
  disabled,
  className,
  ...restProps
}: Props) {
  const onClick = (e: MouseEvent<HTMLDivElement>) => {
    const clickedValue = e.currentTarget.dataset.value!;
    if (value !== clickedValue) {
      onChange(clickedValue);
    }
  };
  return (
    <div
      className={classNames(
        "ac-segmented",
        { "ac-segmented-disabled": disabled },
        className,
      )}
      {...restProps}
    >
      {items.map((item) => {
        const { value: itemValue, label } = !isPlainObject(item)
          ? { label: item as string, value: item as string }
          : (item as ItemTypeObject);
        return (
          <div
            className={classNames("ac-segmented-item", {
              selected: itemValue === value,
            })}
            key={itemValue}
            data-value={itemValue}
            onClick={disabled ? noop : onClick}
          >
            {label}
          </div>
        );
      })}
    </div>
  );
}
